module.exports = __webpack_public_path__ + "media/images/common/icon/icon-fb-w-735919648de8e1bc782952e361bd67e3.svg";